export const btnLocationEnum = {
  productCard: 'Product Card',
  productAccordion: 'Product Accordion',
  cart: 'Cart',
  learnMore: 'Learn More',
  search: 'Flash Sale Search',
  preSalePage: 'Pre-Sale Page',
  saleBanner: 'Sale Banner',
  floatingCTA: 'Floating CTA',
};

export const productAvailabilityEnum = {
  outOfStock: 'OOS',
  inStock: 'In Stock',
};

export const segmentEnum = {
  productViewed: 'Product Viewed',
  productAdded: 'Product Added',
  productRemoved: 'Product Removed',
  productFavorited: 'Product Favorited',
  productUnfavorited: 'Product Unfavorited',
  clickedElement: 'Clicked Element',
  searchSubmitted: 'Search Submitted',
  FBProductAdded: 'FB Product Added',
  rateAndReview: 'Reviews Accessed',
};

export const ACCOUNT_TRACK_NAMES = {
  started: 'Account Update Started',
  completed: 'Account Update Completed',
};

export const ACCOUNT_SECTIONS = {
  billing: 'Billing Info',
  personal: 'Personal Info',
  shipping: 'Shipping Info',
};

export const ACCOUNT_INFO = {
  payment: 'Payment',
  address: 'Address',
  name: 'Name',
  email: 'Email',
};

export const MY_ACCOUNT_EXPERIENCE = 'my account';
